import { apiClient } from '@/services/api';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { ENDPOINTS } from '@/settings/api-settings';
import { IParameter } from '@/interfaces/parameters';
import { ACTIVE_PARAMETERS_TYPES } from '@/settings/consts/parameters-keys';

function getParameters(): Observable<IParameter[]> {
  return from(apiClient.get(ENDPOINTS.PARAMETERS)).pipe(
    map((r: any) => {
      if (!r.data) {
        return [];
      }
      const isEditable = (item) => {
        const NOT_FOUND = -1;
        return (
          // ACTIVE_PARAMETERS_TYPES.indexOf(item.tipoParametro) !== NOT_FOUND
          true
        );
      };
      return r.data.filter(isEditable);
    }),
  );
}

function getParametersOverrides(filter?: any): Observable<IParameter[]> {
  return from(apiClient.get(`${ENDPOINTS.PARAMETERS_OVERRIDE}`, filter)).pipe(
    map((r: any) => r.data),
  );
}

function saveParameter(payload: IParameter): Observable<any> {
  return from(apiClient.post(ENDPOINTS.PARAMETERS, payload)).pipe(
    map((r: any) => r.data),
  );
}

function updateParameter(payload: IParameter): Observable<any> {
  return from(apiClient.put(ENDPOINTS.PARAMETERS, payload)).pipe(
    map((r: any) => r.data),
  );
}

function getParameter(id: string): Observable<IParameter> {
  return from(apiClient.get(`${ENDPOINTS.PARAMETERS}/id/${id}`)).pipe(
    map((r: any) => r.data),
  );
}

function deleteParameter(id: string): Observable<any> {
  return from(apiClient.delete(`${ENDPOINTS.PARAMETERS}/${id}`)).pipe(
    map((r: any) => r.data),
  );
}

export function saveFileParameter(file): Observable<any> {
  return from(apiClient.postMultipartFormData(`${ENDPOINTS.PARAMETERS_FILES}`, {file})).pipe(
    map((r: any) => r.data),
  );
}

function getReasons(filter?: any): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CANCELLATION_REASONS, filter)).pipe(
    map((r: any) => (!!r.data ? r.data : {})),
  );
}
export function getAlterPrescriptionReasons(filter?: any): Observable<any> {
  return from(apiClient.get(ENDPOINTS.ALTER_PRESCRIPTION_REASONS, filter)).pipe(
    map((r: any) => (!!r.data ? r.data : {})),
  );
}

export function getLockPrescriptionReasons(filter?: any): Observable<any> {
  return from(apiClient.get(ENDPOINTS.LOCK_PRESCRIPTION_REASONS, filter)).pipe(
    map((r: any) => (!!r.data ? r.data : {})),
  );
}

function getInfusionTime(filter?: any): Observable<any> {
  return from(apiClient.get(ENDPOINTS.INFUSION_TIME, filter)).pipe(
    map((r: any) => (!!r.data ? r.data : {})),
  );
}

function getSchedulingLimit(filter?: any): Observable<any> {
  return from(apiClient.get(ENDPOINTS.SCHEDULING_LIMIT, filter)).pipe(
    map((r: any) => {
      if (!!r.data && !!!!r.data.valores && !!r.data.valores.length) {
        return r.data.valores[0].valor;
      } else {
        return null;
      }
    }),
  );
}

function getExpirationTimeParam(filter?: any): Observable<any> {
  return from(apiClient.get(ENDPOINTS.EXPIRATION_TIME, filter)).pipe(
    map((r: any) => {
      if (!!r.data && !!!!r.data.valores && !!r.data.valores.length) {
        return r.data.valores[0].valor;
      } else {
        return null;
      }
    }),
  );
}

export {
  getParameters,
  getParametersOverrides,
  updateParameter,
  saveParameter,
  getParameter,
  deleteParameter,
  getReasons,
  getSchedulingLimit,
  getExpirationTimeParam,
  getInfusionTime,
};
